module.exports = __webpack_public_path__ + "img/多边形.a30458c3.svg";